import ApplicationStatus from '../../components/applicationStatus/ApplicationStatus';
import { HeaderHandler } from '../../components/HeaderHandler/HeaderHandler';

export default function CheckApplication() {
  return (
    <>
      <HeaderHandler />
      <ApplicationStatus />
    </>
  );
}
